import { HttpService } from '@/infra/http'

export const FluxoPagamentoMap = {
  Entrada: 'Entrada',
  Mensais: 'Mensais',
  Intermediarias: 'Intermediárias',
  Saldo: 'Saldo',
  PosConclusao: 'Mensais pós-conclusão',
  IntermediariasPosConclusao: 'Intermediárias pós-conclusão',
  Ato: 'Ato',
} as const

export interface IParcelaFluxoPagamento {
  data: string
  tipoDaParcela: keyof typeof FluxoPagamentoMap
  valor: string
}

export interface IFluxoPagamento {
  ano: number
  parcelas: IParcelaFluxoPagamento[]
}

export class GetFluxoPagamentosService extends HttpService {
  execute = async (ids: string[]) => {
    return this.http.get<IFluxoPagamento[]>('api/v2/Simulacao/fluxoPagamento', {
      params: { ids },
      paramsSerializer: { indexes: null },
    })
  }
}
